module.exports = __webpack_public_path__ + "img/andreas_h.d84b0ceb.jpg";